module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-datetime"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Datetime Picker")]), _vm._v(" "), _c('div', {
    staticClass: "page-datetime-wrapper"
  }, [_c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.open('picker1')
      }
    }
  }, [_vm._v("点击弹出 DateTime Picker")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.open('picker2')
      }
    }
  }, [_vm._v("点击弹出 Date Picker")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.open('picker3')
      }
    }
  }, [_vm._v("点击弹出 Time Picker")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.open('picker4')
      }
    }
  }, [_vm._v("自定义模板")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.open('picker5')
      }
    }
  }, [_vm._v("设定初始值")])], 1), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker1",
    attrs: {
      "closeOnClickModal": false
    },
    on: {
      "visible-change": _vm.handleVisibleChange,
      "confirm": _vm.handleChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker2",
    attrs: {
      "type": "date"
    },
    on: {
      "confirm": _vm.handleChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker3",
    attrs: {
      "type": "time"
    },
    on: {
      "confirm": _vm.handleChange
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker4",
    attrs: {
      "type": "date",
      "year-format": "{value} 年",
      "month-format": "{value} 月",
      "date-format": "{value} 日"
    },
    on: {
      "confirm": _vm.handleChange
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker5",
    attrs: {
      "type": "time"
    },
    on: {
      "confirm": _vm.handleChange
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e374e616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/datetime-picker.vue
// module id = 324
// module chunks = 0